export default {
	Title: 'IMPORT GOODS DECLARATION (CUSTOMS CLEARANCE)',
	CustomsDeclaration: 'Customs declaration',
	CustomsDeclarationTrash: 'Deleted declaration',
	AddDeclaration: 'Add',
	EmptyStateTitle: 'You have no customs declarations',
	EmptyStateDesc: 'Add a customs declaration to get started',
	EmptyStateTrashTitle: 'You have no deleted declarations',
	ViewDeclaration: 'View declaration',
	PlaceholderSearchNew: 'Enter Customs Declaration No., Exporter to search',
	Filter: 'Filter declarations',
	DeclarationNo: 'Customs Declaration No.',
	DeclarationDate: 'Customs Declaration Date',
	ReceivedDate: 'Date of receipt of declaration',
	Exporter: 'Exporter',
	BuyerTaxCode: 'Tax code',
	BuyerAddress: 'Address',
	TotalDeclarationAmount: 'Total invoice amount',
	TotalDeclarationAmountExchange: 'Total converted invoice  amount',
	TotalPreCustomsFee: 'Total cost before customs',
	TotalPreCustomsFeeExchange: 'Total converted pre-customs cost',
	TotalTaxValue: 'Total taxable amount',
	TotalTaxAmount: 'Total tax amount',
	AmountAfterTax: 'Total amount after tax',
	TotalAmount: 'Total converted payment amount',
	CcyCode: 'Currency',
	ExchangeRate: 'Exchange Rate',
	CompanyName: "Company's Name",
	CompanyTaxCode: "Company's Tax code",
	BranchName: 'Branch',
	BranchTax: "Branch's Tax code",
	DepartmentName: 'Department Name',
	FirstDeclarationNo: 'First Customs Declaration No.',
	CustomsName: 'Customs Authority’s name',
	CreatedDate: 'Registration Date',
	WaybillNumber: 'Bill of lading No.',
	Importer: 'Importer',
	ImporterCode: 'Code',
	ImporterName: 'Name',
	ImporterAddress: 'Address',
	ExporterCode: 'Code',
	ExporterName: 'Name',
	ExporterAddress: 'Address',
	FeeHQ: 'Exchange Pre-customs cose',
	Adjustment: 'Adjustment',
	Adjustment2: 'Adjustment 2',
	Adjustment3: 'Adjustment 3',
	Adjustment4: 'Adjustment 4',
	Adjustment5: 'Adjustment 5',
	TransportFee: 'Transport Fee',
	InsuranceFees: 'Insurance Fee',
	Tax: 'Tax amount',
	ImportTax: 'Import Tax',
	VatTax: 'VAT Tax',
	TTDBTax: 'Special Consumption Tax',
	STT: 'No.',
	InventoryItemCode: 'Invetory Item Code',
	InventoryItemName: 'Inventory Item Name',
	UnitName: 'Unit',
	Quantity: 'Quantity',
	UnitPrice: 'Unit Price',
	Amount: 'Amount',
	AmountExchange: 'Exchange amount',
	TaxPrice: 'Taxable value',
	ImportTaxTable: 'Import Tax',
	EnvironmentTax: 'Environmental Tax',
	EnvironmentTaxMaster: 'Environmental Tax',
	DumpingTax: 'Anti-dumping Tax',
	TTDB: 'Special Consumption Tax',
	TS: 'Rate',
	SumValue: 'Total invoice amount: ',
	SumTaxBeforeFee: 'Total pre-customs fee: ',
	SumTax: 'Total tax amount: ',
	SumAmount: 'Total payment amount: ',
	SumValueTooltip: 'Total invoice amount exchange',
	SumTaxBeforeFeeTooltip: 'Total pre-customs fee exchange',
	SumTaxTooltip: 'Total tax amount exchange',
	SumAmountTooltip: 'Total payment amount exchange',
	FileError: 'Unsupported format',
	FileNotRead: 'Can not read the Customs Declaration',
	FileDuplicate: 'Duplicate Customs Declaration',
	FileRecommend: 'Please upload the xml, excel file of the Import Goods Declaration (Customs Clearance)',
	Period: 'Declaration Date',
	FileCanDownload: 'Upload *xls, *xlsx, *xml file of import customs declaration (customs clearance)',
	AlertPresentationXML:
		'This is a viewer based on the content of XML, Excel file of the Customs Declaration. This content may not be correct according to the  form of the actual Customs Declaration.',
	RowSum: 'Total',
	NotPermissionViewDeclaration: 'You do not have permission to view invoices at',
	NonDeclarationData:
		'There is no import customs declaration (customs clearance), please upload (*xls, *xlsx, *xml) here.',
	WarningNonData: 'Note: For each uploaded customs declaration, resources such as invoices will be deducted.',
	Export: {
		MessageNotifiExportLimit: number =>
			`Export data will be retrieved according to the filter conditions on the list , <b class='font-bold'>maximize ${number} customs</b>.`
	},
	DeleteDeclarationTitle: 'Delete declaration',
	DeleteDeclarationMess: 'Deleted data can still be restored in the "Deleted declarations" section.',
	DeleteDeclarationBatchMess: 'Are you sure you want to delete the selected declarations?',
	DeleteProcessing: count => `Processing deletion of ${count} declarations...`,
	DeleteSuccess: 'Deleted declaration successfully',
	DeletePartialSuccess: ({ successCount, totalCount, failCount }) =>
		`Deleted ${successCount}/${totalCount} declarations. ${failCount} declarations could not be deleted.`,
	DeleteExceedLimitTitle: 'Row limit exceeded',
	DeleteError: 'Delete failed',
	RestoreError: 'Restore failed',
	RestoreSuccess: 'Restore successfully',
	MoveDeclaration: 'Transfer declaration',
	blockedPopupTitle: 'Cannot transfer customs declaration',
	blockedTransferToSpecialUnit:
		'The receiving unit <strong>{unitName}</strong> is a third-party invoice verification unit and <span style="color:#f5222d;font-weight:600">does not have the feature</span> to receive customs declarations.',
	blockedTransferToSpecialUnitNote: 'Please check the receiving unit again to avoid errors.',
	TooltipViewDetail: 'See declaration details',
	// BỔ SUNG: Translation keys cho combobox "Xem thông tin"
	ViewAllDeclarations: 'View all declarations',
	ViewSelectedDeclarations: 'View only selected declarations',
	DeclarationListSelected: 'List of selected declarations',
	TotalDeclaration: 'Total declarations',
	DeclarationSelected: count => `${count} declaration${count > 1 ? 's' : ''}`,
	MaxDeclarationSelectWarning: maxNumber => `You can only select up to ${maxNumber} declarations.`,
	DownloadOriginalDeclaration: 'Download original declaration',
	DownloadingOriginalFile: 'Downloading original declaration...'
};
